function initCurrencyConvert() {
  convertYen();
}

document.addEventListener('DOMContentLoaded', initCurrencyConvert);

document.addEventListener(
  'shopify:section:load',
  initCurrencyConvert
);


async function convertYen() {

  const currentUrl = window.location.href.toLowerCase();
  const isCnUrl = /(?:-cn\/|\-cn$)/.test(currentUrl);

  // 通貨の定義
  const currencies = {
    gbp: ['United Kingdom', '£'],
    azn: ['Azerbaijan', '₼'],
    afn: ['Afghanistan', '؋'],
    usd: ['United States', '$'],
    aed: ['United Arab Emirates', 'د.إ'],
    dzd: ['Algeria', 'دج'],
    amd: ['Armenia', '֏'],
    aoa: ['Angola', 'Kz'],
    yer: ['Yemen', '﷼'],
    iqd: ['Iraq', 'ع.د'],
    inr: ['India', '₹'],
    idr: ['Indonesia', 'Rp'],
    xpf: ['French Pacific Territories', '₣'],
    ugx: ['Uganda', 'USh'],
    uzs: ['Uzbekistan', 'soʻm'],
    egp: ['Egypt', '£'],
    szl: ['Eswatini', 'E'],
    etb: ['Ethiopia', 'Br'],
    ern: ['Eritrea', 'Nfk'],
    omr: ['Oman', '﷼'],
    aud: ['Australia', '$'],
    kzt: ['Kazakhstan', '₸'],
    qar: ['Qatar', '﷼'],
    xaf: ['Central African CFA Zone', 'FCFA'],
    khr: ['Cambodia', '៛'],
    cve: ['Cape Verde', 'Esc'],
    gmd: ['Gambia', 'D'],
    ghs: ['Ghana', '₵'],
    eur: ['Eurozone', '€'],
    kgs: ['Kyrgyzstan', 'сом'],
    gnf: ['Guinea', 'FG'],
    xof: ['West African CFA Zone', 'CFA'],
    kwd: ['Kuwait', 'د.ك'],
    nzd: ['New Zealand', '$'],
    kes: ['Kenya', 'KSh'],
    kmf: ['Comoros', 'CF'],
    cdf: ['Democratic Republic of the Congo', 'FC'],
    sar: ['Saudi Arabia', '﷼'],
    wst: ['Samoa', 'WS$'],
    stn: ['São Tomé and Príncipe', 'Db'],
    zmw: ['Zambia', 'ZK'],
    sll: ['Sierra Leone', 'Le'],
    sgd: ['Singapore', '$'],
    djf: ['Djibouti', 'Fdj'],
    gel: ['Georgia', '₾'],
    zwl: ['Zimbabwe', 'Z$'],
    lkr: ['Sri Lanka', 'Rs'],
    sdg: ['Sudan', 'ج.س.'],
    shp: ['Saint Helena', '£'],
    scr: ['Seychelles', '₨'],
    sos: ['Somalia', 'S'],
    sbd: ['Solomon Islands', '$'],
    thb: ['Thailand', '฿'],
    tjs: ['Tajikistan', 'SM'],
    tzs: ['Tanzania', 'TSh'],
    tnd: ['Tunisia', 'د.ت'],
    tmt: ['Turkmenistan', 'm'],
    try: ['Türkiye', '₺'],
    top: ['Tonga', 'T$'],
    ngn: ['Nigeria', '₦'],
    nad: ['Namibia', '$'],
    npr: ['Nepal', '₨'],
    vuv: ['Vanuatu', 'VT'],
    bdt: ['Bangladesh', '৳'],
    bhd: ['Bahrain', '.د.ب'],
    pkr: ['Pakistan', '₨'],
    pgk: ['Papua New Guinea', 'K'],
    ils: ['Israel', '₪'],
    fjd: ['Fiji', '$'],
    php: ['Philippines', '₱'],
    brl: ['Brazil', 'R$'],
    bnd: ['Brunei', '$'],
    bif: ['Burundi', 'FBu'],
    btn: ['Bhutan', 'Nu.'],
    vnd: ['Vietnam', '₫'],
    bwp: ['Botswana', 'P'],
    mga: ['Madagascar', 'Ar'],
    mwk: ['Malawi', 'MK'],
    myr: ['Malaysia', 'RM'],
    mmk: ['Myanmar', 'K'],
    mxn: ['Mexico', '$'],
    mzn: ['Mozambique', 'MT'],
    mvr: ['Maldives', 'Rf'],
    mad: ['Morocco', 'د.م.'],
    mnt: ['Mongolia', '₮'],
    mur: ['Mauritius', '₨'],
    mru: ['Mauritania', 'UM'],
    jod: ['Jordan', 'د.ا'],
    lak: ['Laos', '₭'],
    lyd: ['Libya', 'ل.د'],
    lrd: ['Liberia', '$'],
    rwf: ['Rwanda', 'FRw'],
    lsl: ['Lesotho', 'L'],
    lbp: ['Lebanon', 'ل.ل'],
    cny: ['China', '¥'],
    mop: ['Macau', 'MOP$'],
    hkd: ['Hong Kong', 'HK$'],
    zar: ['South Africa', 'R'],
    // ssp: ['South Sudan', '£'],
    twd: ['Taiwan', 'NT$'],
    jpy: ['Japan', '¥'],
    krw: ['South Korea', '₩'],
  }

  // 現在の設定通貨
  const activeCurrency = Shopify.currency.active.toLowerCase();

  // 通貨の定義に存在しない場合はusdを使用
  if (!currencies[activeCurrency]) {
    activeCurrency = 'usd';
  }

  // レートを取得
  const rateCacheUrl = 'https://contents.sousou.co.jp/other/scripts/shop/cache/currency_rate/' + activeCurrency + '.cache';
  try {
    const response = await fetch(rateCacheUrl);
    const rateConvertTo = await response.json();

    // テキストノード走査
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    // 変換
    textNodes.forEach(node => {

      // 親タグ除外
      const parentTag = node.parentElement?.tagName;

      if (
        ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parentTag)
      ) {
        return;
      }
      let text = node.nodeValue;

      // 現在の設定通貨が「cny」で、価格にドットを含む場合は変換しない
      if (isCnUrl && activeCurrency === 'cny') {
        if (/\d+\.\d+/.test(text)) {
          return;
        }
      }

      // 変換処理
      const regex = /(?:[¥￥]\s?([0-9０-９,，]+)|([0-9０-９,，]+)\s?円)/g;
      text = text.replace(regex, (match, price1, price2) => {

        // カンマ削除
        let value = (price1 || price2).replace(/[，,]/g, '');

        // 半角判定
        let is_han = /[０-９]/.test(value) ? 0 : 1;

        // 半角数字に変換
        value = value.replace(/[０-９]/g, s =>
          String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
        );
        value = parseInt(value, 10);        
        if (isNaN(value)) {
          return match;
        }

        // レート変換
        const converted = value * rateConvertTo;
        let convertedPrice;
        if (is_han) {
            // 半角 → 整数切り上げ
            convertedPrice = Math.ceil(converted).toLocaleString();
        } else {
            // 全角 → 小数第2位で切り上げ
            convertedPrice = (Math.ceil(converted * 1000) / 1000).toLocaleString(
            undefined,
            {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            }
          );
        }
    
        // 通貨記号
        const currencySymbol = currencies[activeCurrency]?.[1] || '$';

        return `${currencySymbol}${convertedPrice}`;
      });

      node.nodeValue = text;
    });

  } catch (error) {

  }

}

